import { Modal } from 'antd';
import { setPopUpMessageData } from 'app/store/state/jobs/action';
import { isEqual } from 'app/utils/javascript';
import success from "assets/logos/success.svg";
import warning from "assets/logos/warning.png";
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UGButton from 'shared/UGButton';
import ViewJobsModal from './ViewJobsModal';

const PopUpMessage = ({ t, modal, setModal, footer, message, onOk, setMessage, icons, deselectCylinder, handleClose, okText, cancelText, messageOptions }) => {
    const dispatch = useDispatch();
    const msgValue = useSelector((state) => state.jobs.messageData)
    const entity = useSelector((state) => state.home.entity)
    const currentModal = modal === undefined ? msgValue?.modal : modal;
    const currentMsg = message === undefined ? msgValue?.message : message;
    const iconsArray = msgValue?.icons && msgValue?.icons?.length ? msgValue?.icons : icons;
    const [jobsModal, setJobsModal] = useState({ flag: false, status: "ALL" })
    const handleCancel = () => {
        handleClose && handleClose()
        if (modal !== undefined) {
            setModal(false);
            setMessage([]);
        }
        dispatch(setPopUpMessageData({ modal: false, message: [], onlyOkBtnFooter: false }))
    }

    const footerFn = () => (
        (msgValue?.onlyOkBtnFooter) ?
            (
                <div className="text-center mb-0">
                    <UGButton type="primary" className="btn ok-btn mb-0" onClick={handleCancel}>{t("ok")}</UGButton>
                </div >
            )
            :
            (
                <div className="text-center mb-0">
                    <UGButton type="primary" className="btn ok-btn mb-0" onClick={handleCancel}>{cancelText ? t(cancelText) : deselectCylinder?.flag ? t("no") : t("cancel")}</UGButton>
                    <UGButton type="primary" className="btn ok-btn mb-0" onClick={onOk} > {okText ? t(okText) : deselectCylinder?.flag ? t("yes") : t("proceed")
                    }</UGButton>
                </div >
            )
    )

    const handleJobsModal = () => {
        setJobsModal({ ...jobsModal, flag: true, cylinderId: msgValue?.deleteCylinderId, status: isEqual(msgValue?.method, "post") ? "ACTIVE" : "ALL" })
        dispatch(setPopUpMessageData({ modal: false, message: [] }))
    }
    const translateMessage = (val) => t(`translation:${val}`, { defaultValue: val, ...(messageOptions?.[val] || {}) })
    return (
        <>
            <Modal
                visible={currentModal} /* onOk={} */
                onCancel={handleCancel}
                footer={footer ? [footerFn()] : []}
                wrapClassName={`message-popup ${!footer ? "no-footer" : ""}`}
                maskStyle={{ zIndex: 12 }}
                closable={false}
            >
                {iconsArray ?
                    <div>
                        {currentMsg && currentMsg?.length ? currentMsg?.map((val, index) => {
                            return (
                                <div className="d-flex" key={index}>
                                    <img src={iconsArray?.[index]} alt="" height="45" width="45" className="mr-8" />
                                    <p className="text-start font-15 my-auto">{t(val)}</p>
                                </div>
                            )
                        }) : null}
                    </div >
                    : <div>
                        {currentMsg && currentMsg.length ?
                            <>
                                {!msgValue?.headerFlag ?
                                    <><img src={msgValue?.success ? success : warning} alt="" height="30" /> <b className="font-16">{t(msgValue?.success ? "msgSuccess" : "warning")}</b></> : null}
                                <ul className={`${!msgValue?.headerFlag && 'mb-0 mt-3'}`}>{currentMsg && currentMsg.length ? currentMsg.map((val, index) => {
                                    const msg = val && val?.split("&");
                                    if (msg && msg?.length === 1) {
                                        return <li key={index} className={msgValue?.removeBulletFormFistMsg && index === 0 ? "no-bullet mb-10" : "text-start font-15"} style={{ whiteSpace: "pre-line" }}>
                                            {translateMessage(val)}
                                            <span className="cursor-pointer color-dark" onClick={handleJobsModal}>
                                                {isEqual(entity, "VIEW_LIST_CYLINDER") && msgValue?.deleteCylinderId ? `...${t("txtViewAllJobs")}` : null}
                                            </span>
                                        </li>
                                    } else {
                                        return <li key={index}>
                                            {msg && msg?.length && msg?.map(v => {
                                                return <p className="text-start font-15 mb-5" style={{ whiteSpace: "pre-line" }}>{translateMessage(v)}</p>
                                            }
                                            )}
                                        </li>
                                    }
                                }) : null}
                                </ul>
                            </>
                            : null}
                    </div>}
            </Modal >
            {jobsModal?.flag ? <ViewJobsModal {...{ modal: jobsModal, setModal: setJobsModal, cylinderId: jobsModal?.cylinderId }} /> : null}
        </>
    )
}

export default PopUpMessage
